import ListViewDataItem from 'core/classes/ListViewDataItem';
import DoorAccess from '../classes/DoorAccess';
import DoorAccessType from '../classes/DoorAccessType';
import DoorCardRawData from '../classes/DoorCardRawData';
import DoorCodeRawData from '../classes/DoorCodeRawData';

type CardsMap = { [p: string]: DoorCardRawData };
type CodesMap = { [p: string]: DoorCodeRawData };

const generateDoorAccess = (access: DoorCardRawData | DoorCodeRawData, accessType: string) =>
    new DoorAccess({
        ...access.all,
        accessType,
    });

const generateDoorAccessMap = (data: CardsMap | CodesMap, accessType: string) =>
    Object.entries(data).reduce((acc, [id, access]) => {
        return { ...acc, [id]: generateDoorAccess(access, accessType).data };
    }, {});

export const generateDoorAccessMapData = ({ cards, codes }: { cards: CardsMap; codes: CodesMap }) => {
    const list = [...Object.values(cards), ...Object.values(codes)].map((access) => {
        return new ListViewDataItem(access.listViewData);
    });

    return {
        list,
        doorAccessMap: {
            ...generateDoorAccessMap(cards, DoorAccessType.CARD),
            ...generateDoorAccessMap(codes, DoorAccessType.CODE),
        },
    };
};
